<template>
  <div class="welcome"></div>
</template>

<script>
export default {
  name: 'Welcome',
}
</script>

<style scoped>
.welcome {
  height: 100%;
}
</style>
